import React, { useEffect, useState, useRef, useContext } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import { ContextBoard } from "../../context/ContextBoard";
import Swal from "sweetalert2";

function Exregularfirst() {
  const { setClass9exregulardata } = useContext(ContextBoard);
  const navigate = useNavigate();
  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSession] = useState("");
  const [regParts, setRegParts] = useState(["", "", ""]);
  const inputRefs = [useRef(), useRef(), useRef()];
  const [loading, setLoading] = useState(true);

  const [EndDate, setEndDate] = useState("");
  const date = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const currentDate = `${day}-${month}-${year}`;
  const parseDate = (str) => {
    const [dd, mm, yyyy] = str.split("-");
    return new Date(`${yyyy}-${mm}-${dd}`);
  };
  // Fetch sessions on page load
  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const token = sessionStorage.getItem("tokenclassix");
        const response = await fetch(
          `${config.API_BASE_URL}/PageLoadRegistrationSessionEXRegular_CL9`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        // console.log(data);
        setLoading(false);
        setSessions(data.data.sessionExRegular_data.sessions || []);
        setEndDate(data.data.sessionExRegular_data.registrationEnd || "");
      } catch (error) {
        setLoading(false);
        console.error("Failed to fetch sessions", error);
      }
    };
    fetchSessions();
  }, []);

  // Handle registration input
  const handleRegChange = (value, index) => {
    const maxLengths = [5, 5, 2];
    const updated = [...regParts];
    updated[index] = value.replace(/\D/g, "").slice(0, maxLengths[index]);
    setRegParts(updated);

    if (value.length >= maxLengths[index] && index < 2) {
      inputRefs[index + 1].current.focus();
    }
  };

  const handleRegKeyDown = (e, index) => {
    if (e.key === "Backspace" && regParts[index] === "" && index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };
  const handleProceed = async () => {
    const fullReg = regParts.join("-");
    if (
      regParts.some((part, index) => part.length !== [5, 5, 2][index]) ||
      !selectedSession
    ) {
      Swal.fire(
        "Invalid Input",
        "Please enter full 12-digit registration number and select session.",
        "warning"
      );
      return;
    }
    setLoading(true);
    try {
      const token = sessionStorage.getItem("tokenclassix");
      const response = await fetch(
        `${config.API_BASE_URL}/FetchDataEXRegularStudent_CL9`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            registratioN_NO: fullReg,
            sessioN_CODE: selectedSession,
          }),
        }
      );

      const result = await response.json();

      if (result.status === 200) {
        setLoading(false);
        // console.log(result.data.EXRegularStudentCL9_data[0]);
        setClass9exregulardata(result.data.exRegularStudentCL9_data);
        navigate("/class-ix-add-ex-regular-student");
      } else {
        setLoading(false);
        Swal.fire("Warning", result.message || "Validation failed.", "error");
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
      Swal.fire("Error", "Error occurred during validation.", "error");
    }
  };

  return (
    <>
      <div className="container-scroller">
        <Navbar />
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            {parseDate(currentDate) >= parseDate(EndDate) ? (
              <div
                class="content-wrapper"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <h1 className="text-danger">
                  <strong>Registration is closed.</strong>
                </h1>
              </div>
            ) : (
              <div className="content-wrapper">
                <div className="row">
                  <div className="col-md-12 mb-1">
                    <section className="content-header">
                      <h1>
                        <i className="fa fa-user-plus"></i>&nbsp; Add Ex-Regular
                        Student (Student Registration Page for Board
                        Examination)
                      </h1>
                      <ol className="breadcrumb">
                        <li>
                          <a
                            onClick={() => {
                              navigate("/class-ix-dashboard");
                            }}
                            href="#"
                          >
                            <i className="fa fa-home"></i> Home&nbsp;
                          </a>
                        </li>
                        <li className="active">Add Student</li>
                      </ol>
                    </section>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 mb-4 stretch-card">
                    <div className="card">
                      <div className="card-header">
                        <h4 className="mb-0 p-2">Registration Details</h4>
                      </div>
                      <div className="card-body">
                        <div className="row d-flex justify-content-center">
                          <div className="col-md-10 py-3">
                            <div className="row mb-3">
                              <label className="col-md-3">
                                Registration Session :
                              </label>
                              <div className="col-md-8">
                                <select
                                  className="form-select"
                                  value={selectedSession}
                                  onChange={(e) =>
                                    setSelectedSession(e.target.value)
                                  }
                                >
                                  <option value="">Select</option>
                                  {sessions.map((session) => (
                                    <option
                                      key={session.sessioN_CODE}
                                      value={session.sessioN_CODE}
                                    >
                                      {session.sessioN_FULL_NAME}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="row">
                              <label className="col-md-3">
                                Registration Number :
                              </label>
                              {[5, 5, 2].map((len, i) => (
                                <div className="col-md-2" key={i}>
                                  <input
                                    ref={inputRefs[i]}
                                    className="form-control form-control-xs number"
                                    value={regParts[i]}
                                    onChange={(e) =>
                                      handleRegChange(e.target.value, i)
                                    }
                                    onKeyDown={(e) => handleRegKeyDown(e, i)}
                                  />
                                  <p>{len} Digits Only</p>
                                </div>
                              ))}
                            </div>

                            <div className="row mt-4">
                              <div className="col-md-3"></div>
                              <div className="col-md-offset-3 col-md-8">
                                <div className="row">
                                  <div className="col-md-8">
                                    <button
                                      type="button"
                                      onClick={handleProceed}
                                      className="btn btn-block btn-sm proceed-btn"
                                      style={{
                                        fontSize: "16px",
                                        padding: "8px",
                                        backgroundColor: "#FF0000",
                                        color: "white",
                                        fontWeight: "600",
                                      }}
                                    >
                                      CLICK HERE TO VALIDATE & PROCEED
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default Exregularfirst;
